import React from "react";
import PropTypes from "prop-types";

const PageSizeOptions = ({ pageSize, onChange }) => {
  const pageSizes = [2, 5, 10, 25, 50, 100];

  return (
    <>
      <style>{`
        .page-size-wrapper {
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .page-size-label {
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          white-space: nowrap;
          letter-spacing: 0.3px;
        }

        .page-size-select {
          appearance: none;
          -webkit-appearance: none;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 10px center !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          padding: 5px 28px 5px 10px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          cursor: pointer !important;
          outline: none !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          min-width: 64px !important;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .page-size-select:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
        }

        .page-size-select:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
        }

        .page-size-rows-label {
          font-size: 12px;
          font-weight: 600;
          color: #94a3b8;
          white-space: nowrap;
        }
      `}</style>

      <div className="page-size-wrapper">
        <span className="page-size-label">Show</span>
        <select
          className="page-size-select"
          value={pageSize}
          onChange={onChange}
          aria-label="Select page size"
        >
          {pageSizes.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <span className="page-size-rows-label">rows</span>
      </div>
    </>
  );
};

PageSizeOptions.propTypes = {
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

export default PageSizeOptions;
